export default __webpack_public_path__ + "static/lozenge-dropdown-dont-2-dark-ff5222fe263235d0f70a103b67c4c7cf093323eb1a100b3c0cb4218a7fdd54b2.png";